import { css } from "styled-components";

export const largeSizeStyle = css`
  height: 44px;
  padding: 0 var(--gap-4);
  gap: var(--gap-2);
  font-size: var(--font-size-body);
  line-height: var(--line-height-body);

  svg {
    height: 18px;
    width: auto;
  }
`;
